"use client"

import { Spotlight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SpotlightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SpotlightIcon = component(Icon)({ as: Spotlight })
